import { Component, OnInit, Renderer2 } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { SideBarComponent } from "./shared/menu/side-bar/side-bar.component";
import { Menu } from "./shared/menu/side-bar/menu";
import { NavBarHorizontalComponent } from "./shared/menu/nav-bar-horizontal/nav-bar-horizontal.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "CreditFactory";

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private _sidebarComponent: SideBarComponent,
    private _sideBarMenu: Menu,
    private _navBarHorizontalComponent: NavBarHorizontalComponent
    
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        _sideBarMenu.toggleActiveLink();
        _sidebarComponent.refreshHeader();
        _navBarHorizontalComponent.refreshHeader();
      }
    });
  }
 
  ngOnInit(): void {
    /*this.renderExternalStylesheet('./assets/plugins/pace/pace-theme-flash.css').onload = () => {
        console.log('css loaded');
      };

      this.renderExternalStylesheet('./assets/plugins/bootstrap/css/bootstrap.min.css').onload = () => {
        console.log('css loaded');
      };

      this.renderExternalStylesheet('./assets/fonts/font-awesome/css/font-awesome.css').onload = () => {
        console.log('css loaded');
      };

      this.renderExternalStylesheet('./assets/css/animate.min.css').onload = () => {
        console.log('css loaded');
      };

      this.renderExternalStylesheet('./assets/plugins/perfect-scrollbar/perfect-scrollbar.css').onload = () => {
        console.log('css loaded');
      };

      this.renderExternalStylesheet('./assets/plugins/morris-chart/css/morris.css').onload = () => {
        console.log('css loaded');
      };*/

    /*this.renderExternalStylesheet('./assets/css/style.css').onload = () => {
        console.log('css loaded');
     };*/

    /*this.renderExternalStylesheet('./assets/css/responsive.css').onload = () => {
        console.log('css loaded');
      };*/

    /*this.renderExternalScript('./assets/js/jquery-3.2.1.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/js/popper.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/js/jquery.easing.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/js/chart-echarts.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/bootstrap/js/bootstrap.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/pace/pace.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/perfect-scrollbar/perfect-scrollbar.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }*/

    /*this.renderExternalScript('./assets/plugins/viewport/viewportchecker.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/echarts/echarts-custom-for-dashboard.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/icheck/icheck.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/morris-chart/js/raphael-min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/morris-chart/js/morris.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/inputmask/min/jquery.inputmask.bundle.min.js').onload = () => {
        console.log('jscolor js Script loaded');
      }
      
      this.renderExternalScript('./assets/plugins/echarts/echarts-all.js').onload = () => {
        console.log('jscolor js Script loaded');
      }*/

    this.renderExternalScript("./assets/js/scripts.js").onload = () => {
      console.log("jscolor js Script loaded");
    };
  }

  renderExternalScript(src: string): HTMLScriptElement {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  renderExternalStylesheet(href: string): HTMLLinkElement {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
    return link;
  }
}
